import { z } from "zod";

import { defaultItem, defaultUrl, itemSchema, urlSchema } from "../shared";

// Schema — title may be stored on `name` and/or `url.label` (Masters Union title + link field)
export const publicationSchema = itemSchema
  .extend({
    name: z.string().default(""),
    publisher: z.string(),
    date: z.string(),
    summary: z.string(),
    url: urlSchema,
  })
  .refine(
    (data) =>
      (data.name ?? "").trim().length > 0 ||
      (data.url?.label ?? "").trim().length > 0 ||
      (data.url?.href ?? "").trim().length > 0,
    { path: ["name"], message: "Title or website is required" },
  );

// Type
export type Publication = z.infer<typeof publicationSchema>;

// Defaults
export const defaultPublication: Publication = {
  ...defaultItem,
  name: "",
  publisher: "",
  date: "",
  summary: "",
  url: defaultUrl,
};
